import React from "react";
import {
  Divider,
  Grid,
} from "@mui/material";
import {
  instanceMetaData,
} from "../../redux/api/api.types";
import InstanceContactRow from "./InstanceContactRow";
import InstanceResellerTableRow from "./InstanceResellerTableRow";
import InstanceSellerTableRow from "./InstanceSellerTableRow";

export default function InstanceContactDataTable (type: string, data: instanceMetaData) {
  const renderContactTable = ({resellers, sales_contacts: salesContact}: instanceMetaData) => {
    switch (type) {
      case "resellers":
        if (resellers) {
          return resellers.map((entry) => InstanceResellerTableRow(entry));
        }
        return InstanceContactRow({
          rowEmail: "-",
          rowFirst: "-",
          rowLast: "-"
        })
      case "sales":
        if (salesContact) {
          return salesContact.map((entry) => InstanceSellerTableRow(entry));
        }
        return InstanceContactRow({
          rowEmail: "-",
          rowFirst: "-",
          rowLast: "-"
        })
      default:
        break;
      };
    return InstanceContactRow({
      rowEmail: "-",
      rowFirst: "-",
      rowLast: "-"
    });
  };
  let emailHeader = "";
  let lastHeader = "";
  let firstHeader = "";
  switch (type) {
    case "resellers":
      emailHeader = "Reseller Email";
      lastHeader = "Reseller Last Name";
      firstHeader = "Reseller First Name";
      break;
    case "sales":
      emailHeader = "Sales Email";
      lastHeader = "Sales Last Name";
      firstHeader = "Sales First Name";
      break;
    default:
  }
  return (
    <>
      <Grid item xs={12}> 
        <Divider orientation="horizontal" flexItem/>
      </Grid>
      {InstanceContactRow({
        rowEmail: emailHeader,
        rowFirst: firstHeader,
        rowLast: lastHeader
      }, true)}
      {renderContactTable(data)}
    </>
  );
}